'use es6';

import { Record } from 'immutable';
import { MINIMUM_TARGETABLE_AGE, MAXIMUM_TARGETABLE_AGE } from 'AdsUI/lib/Constants';
import I18n from 'I18n';
import { getCountryName } from 'AdsUI/lib/Utils'; // Functions used for parsing the targeting object

const getLocations = geo_locations => {
  const {
    cities = [],
    subcities = [],
    countries = [],
    country_groups = [],
    custom_locations = [],
    places = [],
    regions = [],
    geo_markets = []
  } = geo_locations;
  const locations = [...cities, ...subcities].map(city => I18n.text('creation.targeting.cityName', {
    name: city.name,
    region: city.region,
    country: getCountryName(city.country)
  })).concat(places.concat(regions).filter(place => !!place.name).map(place => I18n.text('creation.targeting.placeName', {
    name: place.name,
    country: getCountryName(place.country)
  }))).concat(geo_markets.map(geoMarket => I18n.text('creation.targeting.geoMarket', {
    name: geoMarket.name,
    country: getCountryName(geoMarket.country)
  }))).concat(country_groups.map(countryGroup => I18n.text(`creation.targeting.countryGroup.${countryGroup}`))).concat(countries.map(country => getCountryName(country))).concat(custom_locations.filter(({
    latitude
  }) => latitude !== undefined).map(({
    address_string,
    latitude,
    longitude
  }) => I18n.text('creation.targeting.customLocation', {
    address: address_string ? `${address_string}, ` : '',
    latitude,
    longitude
  })));
  return locations;
};

const getFieldFromFlexibleSpec = (flexible_spec, fieldName) => {
  if (!flexible_spec) {
    return [];
  }

  return flexible_spec.reduce((output, spec) => spec[fieldName] ? output.concat(spec[fieldName].map(item => item.name)) : output, []);
};

const getGenders = genders => genders.map(gender => I18n.text(`creation.targeting.genders.${gender}`));

export default class FBTargetingRecord extends Record({
  customAudiences: [],
  locations: [],
  ageMin: MINIMUM_TARGETABLE_AGE,
  ageMax: MAXIMUM_TARGETABLE_AGE,
  interests: [],
  behaviors: [],
  lifeEvents: [],
  workPositions: [],
  genders: [],
  connections: [],
  friendsOfConnections: [],
  excludedCustomAudiences: [],
  excludedInterests: [],
  excludedLocations: [],
  excludedConnections: [],
  excludedBehaviors: [],
  excludedLifeEvents: [],
  excludedWorkPositions: []
}) {
  static fromTargeting(targeting) {
    const {
      custom_audiences = [],
      age_min,
      age_max,
      geo_locations = {},
      flexible_spec,
      genders = [],
      connections = [],
      friends_of_connections = [],
      excluded_custom_audiences = [],
      excluded_geo_locations = [],
      excluded_connections = [],
      exclusions = {}
    } = targeting;
    const excludedInterests = exclusions.interests || [];
    const excludedBehaviors = exclusions.behaviors || [];
    const excludedLifeEvents = exclusions.life_events || [];
    const excludedWorkPositions = exclusions.work_positions || [];
    return new FBTargetingRecord({
      customAudiences: custom_audiences.map(audience => audience.name),
      locations: getLocations(geo_locations),
      ageMin: age_min,
      ageMax: age_max,
      interests: getFieldFromFlexibleSpec(flexible_spec, 'interests'),
      behaviors: getFieldFromFlexibleSpec(flexible_spec, 'behaviors'),
      lifeEvents: getFieldFromFlexibleSpec(flexible_spec, 'life_events'),
      workPositions: getFieldFromFlexibleSpec(flexible_spec, 'work_positions'),
      genders: getGenders(genders.filter(gender => gender !== 0)),
      connections: connections.map(connection => connection.name),
      friendsOfConnections: friends_of_connections.map(friend => friend.name),
      excludedLocations: getLocations(excluded_geo_locations),
      excludedCustomAudiences: excluded_custom_audiences.map(audience => audience.name),
      excludedConnections: excluded_connections.map(connection => connection.name),
      excludedInterests: excludedInterests.map(interest => interest.name),
      excludedBehaviors: excludedBehaviors.map(behavior => behavior.name),
      excludedLifeEvents: excludedLifeEvents.map(lifeEvent => lifeEvent.name),
      excludedWorkPositions: excludedWorkPositions.map(workPosition => workPosition.name)
    });
  }

}